import { motion } from "framer-motion";
import { Hexagon, Fingerprint, TrendingUp } from "lucide-react";

const FEATURES = [
  {
    icon: Hexagon,
    title: "5 Resistance Knobs",
    desc: "Five pressure points isolate each finger for asymmetric strength training. Hit angles a barbell can't.",
    stat: "05 / AXIS",
  },
  {
    icon: Fingerprint,
    title: "Ergonomic Dimple Grip",
    desc: "Precision-tooled micro-dimples lock the palm under load, eliminating slip during max-tension reps.",
    stat: "182 / POINTS",
  },
  {
    icon: TrendingUp,
    title: "Progressive Tension System",
    desc: "One adjustable unit ramps from 40 lb to 99 lb as forearm capacity grows. Train every tier in a single sphere.",
    stat: "40→99 / LB",
  },
];

const Features = () => {
  return (
    <section id="features" data-testid="features-section" className="relative py-24 md:py-32 border-t border-white/10">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.5 }}
          transition={{ duration: 0.6 }}
          className="flex items-end justify-between flex-wrap gap-6 mb-16"
        >
          <div>
            <div className="text-xs uppercase tracking-[0.3em] text-[#007AFF] mb-4 font-body">// 01 Engineering</div>
            <h2 className="font-heading text-4xl sm:text-5xl lg:text-6xl max-w-2xl leading-[0.95]">
              THREE SYSTEMS.<br/>ONE SPHERE.
            </h2>
          </div>
          <p className="max-w-md text-white/55 text-sm leading-relaxed">
            Designed in collaboration with combat athletes and rock climbers.
            Every surface earns its place.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 border-t border-l border-white/10">
          {FEATURES.map((f, i) => {
            const Icon = f.icon;
            return (
              <motion.article
                key={f.title}
                initial={{ opacity: 0, y: 40 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, amount: 0.3 }}
                transition={{ duration: 0.6, delay: i * 0.12 }}
                className="group relative p-8 md:p-10 border-r border-b border-white/10 hover:bg-white/[0.02] transition-colors"
                data-testid={`feature-card-${i}`}
              >
                <div className="flex items-start justify-between mb-12">
                  <div className="w-12 h-12 flex items-center justify-center border border-white/10 group-hover:border-[#007AFF] group-hover:text-[#007AFF] transition-colors">
                    <Icon className="w-5 h-5" strokeWidth={1.6} />
                  </div>
                  <span className="font-body text-[10px] uppercase tracking-[0.25em] text-white/35">{f.stat}</span>
                </div>
                <h3 className="font-heading text-2xl sm:text-3xl mb-4 tracking-wide">{f.title.toUpperCase()}</h3>
                <p className="text-sm text-white/55 leading-relaxed">{f.desc}</p>

                <div className="absolute top-0 left-0 h-px w-0 bg-[#007AFF] group-hover:w-full transition-all duration-700" />
              </motion.article>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Features;
